<template>
  <div style="background: #f8f8f8">
    <section class="padding-fifteen-lr">
      <b-container>
        
        <b-row>
          <b-col cols="12" class="padding-ten-tb float-left padding-left-none">
            <h5 class="title__name text-xl">Fechas Restringidas</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="float-left padding-left-none">
            <h5 class="main__section_title_color text-large font-weight-600">
              Consulta
            </h5>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="padding-fifteen-lr">
      <b-container>
        <b-row>
          <b-col
            cols="12"
            xs="12"
            sm="12"
            md="12"
            lg="5"
            class="float-right main__section_title_color"
          >
            
            <b-button
              class="bg-orange-btn width-1000"
              v-b-modal.modal-registrar-fecha
            >
              <font-awesome-icon icon="plus" /> Agregar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="padding-fifteen-lr">
      <b-container>
        <b-row>
          <b-col
            xs="12"
            sm="12"
            md="12"
            lg="5"
            class="bg-white section__border-radius align-vertical-middle"
          >
            <b-table :items="dates" :fields="fieldsDate"></b-table>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <b-modal
      no-close-on-backdropP
      hide-footer
      id="modal-registrar-fecha"
      title="Fecha Restringida"
    >
      <b-form @submit="registerDate">
        <b-row>
          <b-col cols="12">
            <b-calendar
              v-model="date"
              @context="onContext"
              locale="en-US"
            ></b-calendar>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" class="text-center">
            <b-button class="bg-orange-btn" type="submit">
              <font-awesome-icon icon="save" /> Guardar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import moment from 'moment';

export default {
  name: "MantenedorFechas",
  data() {
    return {
      selected: null, // Array reference
        optionss: ['list', 'of', 'options'],
      dates: [],
      fieldsDate: ["fechas"],
      date: "",
      context: null,
    };
  },
  computed: {
    ...mapState("module", ["options", "name", "perfil", "username"]),
  },
  created() {
    this.getRestrictedDates();
  },
  methods: {
    onContext(ctx) {
      this.context = ctx;
    },
    async registerDate() {
      event.preventDefault();
      //let month = new Date(this.date).getMonth() + 1;
      
      
      //let current=new Date(this.date)
      const selectedDate = moment(this.date, 'YYYY-MM-DD')
      let day=selectedDate.date()
      let month = selectedDate.month() + 1;
      let year = selectedDate.year(); 
      let years = [];
      console.log(day, month,year)
      years.push(year);
 
      try {
        this.$store.commit("SET_LOADING", true);

        let response = await axios.post(
          process.env.VUE_APP_RESTRICTIONS_BASE+"/restricted_days",
          {
            day: day,
            month: month,
            allYears: false,
            user: this.username,
            years: years,
          },
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        let values = { variant: "success", msg: "Se ha creado exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } catch (error) {
        console.log(error.response.data);
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        let self = this;
         this.timeout = setTimeout(function() {
        self.$bvModal.hide("modal-registrar-fecha");
         self.getRestrictedDates();
        self.$store.commit("setShowAlert", false)
      }, 3000);
      } 
    },
    async getRestrictedDates() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_RESTRICTIONS_BASE +
            "/restricted_days/dates?dateFormat=yyyy-MM-dd"
        );

        const data = response.data.map((row) => {
          return {
            fechas: row,
            text: row,
          };
        });
        this.dates = data;
      } catch (error) {
        console.error(error);
      }
      finally{
        this.$store.commit("SET_LOADING", false);
      }
    },
  },
};
</script>
